'use strict';

var CmdDevice = require('./util/CmdDevice');
var log = require('../../../log/Log').channel('LibertyAvV3');

function LibertyAvV3(ipAddress, username, password, onConnectStatus, onControlStatus, config) {
    this.busy = false;
    this.videoMatrixRoutes = {};
    this.volume = 0;

    CmdDevice.call(this, ipAddress, username, password, onConnectStatus,
        onControlStatus, config);
}

LibertyAvV3.prototype = Object.create(CmdDevice.prototype);

LibertyAvV3.prototype.constructor = LibertyAvV3;

LibertyAvV3.prototype.name = 'LibertyAvV3';
LibertyAvV3.prototype.key = '-LWTYINLDB6KjgT9YqMq';
LibertyAvV3.prototype.isAsync = false;
LibertyAvV3.prototype.rejectAsync = false;
LibertyAvV3.prototype.syncTimeoutMs = 2000;
LibertyAvV3.prototype.sendTerminator = '%';

LibertyAvV3.prototype.ports = [{
    port: 4001,
    verifySend: '50631',
    verifyConnection: /Input:\s*HDMI\s*\d|Input:\s*DP|Input:\s*VGA/i,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
    loginVerifyTimeoutMs: 0
}];

LibertyAvV3.prototype.simulationParams = {
    caps: {
        hasRoomVolume: true,
        hasVideoInputs: true,
        hasVideoOutputs: true,
        hasVideoSwitcher: true,
    }
};

LibertyAvV3.prototype.commands = {};

LibertyAvV3.prototype.commands.$getRouteInit = {};
LibertyAvV3.prototype.commands.$getRouteInit.activeStates = [ 'initializing' ];
LibertyAvV3.prototype.commands.$getRouteInit.activeInitializeStates = [ 'gettingRoutes' ];
LibertyAvV3.prototype.commands.$getRouteInit.get = function() {
    this.sendCommand('$getRouteInit', '50631' );
};
LibertyAvV3.prototype.commands.$getRouteInit.match = /Input:\s*HDMI\s*(\d)|(Input:\s*DP)|(Input:\s*VGA)/i;
LibertyAvV3.prototype.commands.$getRouteInit.process = function(match) {
    if (typeof match[1] !== 'undefined') {
        this.updateVideoMatrixRoute(match[1], '1');
    }
    else if (typeof match[2] !== 'undefined') {
        this.updateVideoMatrixRoute(match[2], '1');
    }
    else if (typeof match[3] !== 'undefined') {
        this.updateVideoMatrixRoute(match[3], '1');
    }
    this.doNextInitializeStep();
};

LibertyAvV3.prototype.commands.busy = {};
LibertyAvV3.prototype.commands.busy.get = function() {
    this.broadcastStatus('busy', this.busy);
};

LibertyAvV3.prototype.commands.ping = {};
LibertyAvV3.prototype.commands.ping.activeStates = [ 'controlling', 'controlFailed' ];
LibertyAvV3.prototype.commands.ping.get = function() {
    this.sendCommand('ping', '50631');
};
LibertyAvV3.prototype.commands.ping.match = /Input:\s*HDMI\s*(\d)|(Input:\s*DP)|(Input:\s*VGA)/i;
LibertyAvV3.prototype.commands.ping.process = function(match) {
    var translatedCode = '1';

    if (typeof match[1] !== 'undefined') {
        // matches HDMI 1, HDMI 2, or HDMI 3
        translatedCode = match[1];
    } else if (typeof match[2] !== 'undefined') {
        // DP input is input 4
        translatedCode = '4';
    } else if (typeof match[3] !== 'undefined') {
        // VGA input is input 5
        translatedCode = '5';
    }

    this.updateVideoMatrixRoute(translatedCode, '1');
};

LibertyAvV3.prototype.commands.videoMatrixRoute = {};
LibertyAvV3.prototype.commands.videoMatrixRoute.get = function() {
    this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);
};
LibertyAvV3.prototype.commands.videoMatrixRoute.set = function(value) {
    if (!this.videoMatrixRoutes.hasOwnProperty(value.videoOutputId)) {
        log.error(this + ' invalid videoOutputId = ' + value.videoOutputId);
        return;
    }

    if (!this.config.videoInputs.hasOwnProperty(value.videoInputId)) {
        log.error(this + ' invalid videoInputId = ' + value.videoInputId);
        return;
    }

    this.videoMatrixRoutes[value.videoOutputId] = value.videoInputId;
    this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);

    this.sendCommand('videoMatrixRoute', '5070' +
        this.config.videoInputs[value.videoInputId].code);
};
LibertyAvV3.prototype.commands.videoMatrixRoute.match = /Switch\sto\s*HDMI\s*(\d)|(Switch\sto\s*DP)|(Switch\sto\s*VGA)/i;
LibertyAvV3.prototype.commands.videoMatrixRoute.process = function(match) {
    var translatedCode = '1';

    if (typeof match[1] !== 'undefined') {
        // matches HDMI 1, HDMI 2, or HDMI 3
        translatedCode = match[1];
    } else if (typeof match[2] !== 'undefined') {
        // DP input is input 4
        translatedCode = '4';
    } else if (typeof match[3] !== 'undefined') {
        // VGA input is input 5
        translatedCode = '5';
    }

    this.updateVideoMatrixRoute(translatedCode, '1');
};

LibertyAvV3.prototype.commands.volume = {};
LibertyAvV3.prototype.commands.volume.get = function() {
    this.broadcastStatus('volume', this.volume);
};
LibertyAvV3.prototype.commands.volume.set = function(value) {
    this.cmdSocket.removeSync('volume');

    // Convert Mira Connect volume range (0-50) to LibertyAvV3 0 to 60
    var scaledValue = Math.round(60 * value / 50);
    this.sendCommand('volume', '510' + scaledValue  );
    this.volume = value;
    this.broadcastStatus('volume', this.volume);
    this.set('volumeMute', value === 0);
};
LibertyAvV3.prototype.commands.volume.match = /Source Volume: (\d*)/i;
LibertyAvV3.prototype.commands.volume.process = function(match) {
    // Convert LibertyAvV3 volume range 0 - 60 to Mira Connect volume 0 - 50 
    var newVolume = Math.round(parseInt(match[1], 10) * 50 / 60);
    if (this.volume !== newVolume) {
        this.volume = newVolume;
        this.broadcastStatus('volume', this.volume);
    }
};

LibertyAvV3.prototype.initializeSteps = [{
    state: 'gettingRoutes',
    action: '$getRouteInit',
    getRepeatCount: function() {
        return this.config.hasOwnProperty('videoOutputs') ?
            Object.keys(this.config.videoOutputs).length : 0;
    },
}, {
    state: 'finishingInitialization',
    action: function() {
        this.finishInitialization();
        return true;
    },
}];

LibertyAvV3.prototype.onComputeCaps = function() {
    var caps = this.getCapsTemplate();
    caps.hasVideoSwitcher = true;
    this.computeCapsFromConfig(caps);
    caps.hasRoomVolume = true;
    caps.hasBusy = true;

    return caps;
};

LibertyAvV3.prototype.onInitialize = function() {
    this.videoMatrixRoutes = {};
    this.startInitializer();
};

LibertyAvV3.prototype.updateVideoMatrixRoute = function(inputCode, outputCode) {
    var inputId = null;
    var outputId = null;

    for (var inId in this.config.videoInputs) {
        if (!this.config.videoInputs.hasOwnProperty(inId)) continue;
        if (this.config.videoInputs[inId].code === inputCode) {
            inputId = inId;
            break;
        }
    }

    if (inputId === null) {
        log.warning(this + ': unmatched video input code: ' + inputCode);
    }

    for (var outId in this.config.videoOutputs) {
        if (!this.config.videoOutputs.hasOwnProperty(outId)) continue;
        if (this.config.videoOutputs[outId].code === outputCode) {
            outputId = outId;
            break;
        }
    }

    if (outputId === null) {
        log.warning(this + ': unmatched video output code: ' + outputCode);
    }

    if (this.videoMatrixRoutes[outputId] !== inputId) {
        this.videoMatrixRoutes[outputId] = inputId;
        if (this.fsm.current === 'controlling') {
            this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);
        }
    }
};

module.exports = LibertyAvV3;
